import styled from '@emotion/styled';
import vars from '@variables';
import { HighlightAtom } from '@atoms/text-atoms/text-atoms';

export const HoneyCombContainer = styled.div<{
  anchorId: string;
}>`
  font-weight: ${vars.fontWeightRegular};
  width: 100%;
  margin: ${({ anchorId }) => (anchorId ? vars.spacingL : '0px')} auto;
  padding-top: 4rem;
  border-top: 1px dashed ${vars.borderGrey};
  margin-top: 3rem;

  ${HighlightAtom} {
    line-height: 1.33;
    display: flex;
    span {
      font-weight: ${vars.fontWeightMedium};
      ${vars.fontSize6}
      line-height: 1.33;
    }
  }

  .hc-block-tabs-list {
    display: flex;
    grid-column: col1-start / col4-end;
    @media screen and (min-width: ${vars.breakPointTablet}) {
      grid-column: col1-start / col12-end;
    }
    position: relative;
  }

  .tabs-separator {
    display: block;
    grid-column: col1-start / col4-end;
    border-top: 1px solid ${vars.coreDarkGrey};
    margin-bottom: 3rem;
    @media screen and (min-width: ${vars.breakPointTablet}) {
      grid-column: col1-start / col12-end;
    }
  }

  .columns-wrapper {
    display: flex;
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap-reverse;
  }

  .left-column {
    padding-right: 1rem;
    width: 30%;

    .left-column-title {
      padding-bottom: -1rem;
      padding-top: 0.2rem;
    }

    @media screen and (max-width: ${vars.breakPointSmallDesktop}) {
      width: 43%;
    }

    @media screen and (max-width: ${vars.breakPointTablet}) {
      width: 100%;
    }

    .info-point-wrapper {
      min-width: 50%;
      margin-top: -10px;
    }

    .map {
      margin-top: 2rem;

      div {
        margin-top: 2rem;
      }
    }

    .map-img {
      width: auto;
      max-width: 112%;
      border-radius: 8px;
      background-color: ${vars.greyHavens};
      border: 1px solid ${vars.greyHavens};
      display: block;
    }

    @media screen and (max-width: 1300px) {
      .img-caption {
        display: none;
      }
    }

    @media screen and (max-width: 1100px) {
      .map-img {
        display: none;
      }
    }

    .info-point {
      display: flex;
      flex-direction: column;
      font-size: 2rem;
      align-items: start;
      width: 110%;
      border-bottom: 1px solid ${vars.borderGrey};

      .info-point-text {
        font-weight: ${vars.fontWeightBold};
        ${vars.fontSize4}
        line-height: 2.5rem;
        padding-bottom: 0.3rem;
      }

      .info-point-blob {
        display: flex;
        font-weight: ${vars.fontWeightMedium};
        ${vars.fontSize3}
        color: ${vars.coreDarkGrey};
        padding-bottom: 1rem;
      }
    }

    .img-caption {
      font-weight: ${vars.fontWeightMedium};
      ${vars.fontSize4}
    }
  }

  .right-column {
    width: 65%;

    @media screen and (max-width: ${vars.breakPointSmallDesktop}) {
      width: 50%;
    }

    @media screen and (max-width: ${vars.breakPointTablet}) {
      width: 100%;
      margin-bottom: 16px;
    }

    .btn-wrapper {
      display: flex;

      button {
        font-size: 1.6rem;
        font-weight: ${vars.fontWeightBold};
        border-radius: 0.5rem;
        border: none;
        height: 5rem;
        margin-right: 1rem;
        margin-bottom: 1.4rem;
        color: white;
        background-color: ${vars.lightGrey};
        cursor: pointer;
        transition: background-color 0.3s ease;
        padding-left: 1rem;
        padding-right: 1rem;
      }

      button:hover {
        background-color: ${vars.stingBlue};
      }

      button.btn-selected {
        background-color: ${vars.stingBlue};
      }
    }

    .image-wrapper {
      .gatsby-image-pos,
      img {
        width: 100%;
        border-radius: 8px;
      }
    }
  }
`;
